import { EditPencil } from '@fountain/fountain-ui-components';
import CustomTooltip from '@fountain/fountain-ui-components/dist/CustomTooltip';
import { IconButton, TableCell, TableRow, Typography } from '@material-ui/core';
import classnames from 'classnames';
import React, { useState, VFC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { REACT_APP_MONOLITH_BASE_URL } from 'runtimeEnvVars';

import { makeSelectAccountSlug } from 'containers/Auth_old/selectors';

import { messages } from './messages';
import { useStyles } from './styles';

interface AutomatedResponseRowProps {
  id: number;
  question: string;
  message: string;
  // eslint-disable-next-line camelcase
  message_template_id: number;
  handleEditAutomatedResponse: (id: number) => void;
}

export const AutomatedResponseRow: VFC<AutomatedResponseRowProps> = ({
  id,
  question,
  message,
  message_template_id: messageTemplateId,
  handleEditAutomatedResponse,
}) => {
  const styles = useStyles();
  const intl = useIntl();
  const accountSlug = useSelector(makeSelectAccountSlug());
  const [showActions, setShowActions] = useState(false);

  return (
    <TableRow
      className={styles.tableRow}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
      onClick={() => handleEditAutomatedResponse(id)}
    >
      <TableCell className={styles.tableCell}>
        <Typography className={styles.cellContent}>{question}</Typography>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <Typography className={styles.cellContent}>{message}</Typography>
      </TableCell>
      <TableCell className={classnames(styles.tableCell, styles.actionCell)}>
        {showActions && accountSlug && (
          <CustomTooltip
            title={intl.formatMessage(messages.editMessageTemplate)}
            dense
          >
            <IconButton
              href={`${REACT_APP_MONOLITH_BASE_URL}/${accountSlug}/message_templates/${messageTemplateId}/edit`}
              target="_blank"
              onClick={event => event.stopPropagation()}
            >
              <EditPencil className={styles.actionIcon} />
            </IconButton>
          </CustomTooltip>
        )}
      </TableCell>
    </TableRow>
  );
};
